<template>
  <v-main>
    <voicemail-drawer />
    <voicemails ref="voicemails" />
    <voicemail-force-enable-ia-dialog />
  </v-main>
</template>

<script>
import Voicemails from '@/components/voicemails'
import VoicemailForceEnableIaDialog from '@/components/voicemails/enable_transcription_snackbar'
import VoicemailDrawer from '@/components/voicemails/drawer/index.vue'
export default {
  name: 'view-voicemails',
  components: {
    Voicemails,
    VoicemailDrawer,
    VoicemailForceEnableIaDialog
  }
}
</script>

<style scoped>
</style>
